export default "__VITE_ASSET__CTF_zu5B__"